<template>
    <form @submit.prevent="submitPhone">
        <label style="padding-top:10px;padding-bottom:20px;" for="phone">شماره موبایل خود را وارد کنید</label>
        <input
        id="phone"
        dir="ltr" 
        v-model="phone"
        type="tel"
        maxlength="11"
        pattern="[0-9]*"
        placeholder="0912 345 67 89"
        required
        />
        <button v-if="showSend" :disabled="submitDisabled" type="submit">
            دریافت کد
            <span v-if="submitDisabled">({{ remainingTime }} ثانیه)</span>
        </button>
    </form>
    <FingerPrintLogin v-if="showFingerPrint" />
</template>
<script setup>
    import { ref,watch,onMounted ,onUnmounted,defineEmits,defineProps } from 'vue'
    import FingerPrintLogin from '@/components/user/fingerPrint/login/FingerPrintLogin.vue'
    import { useUserStore } from '@/stores/user';
    import { useAlertStore } from '@/stores/alert';
    const userStore = useUserStore()
    const alertStore = useAlertStore()
    const submitDisabled=ref(false)
    const sentOnce=ref(false)
    const showSend=ref(false)
    const remainingTime=ref(0)
    const emit = defineEmits(['success'])
    const phone=ref('')
    const props=defineProps({
        phone: String
    })
    const showFingerPrint = ref(false)
    async function phoneHasFinger() {
        const res = await userStore.hasFinger()
        showFingerPrint.value = !!res
    }
    let interval=null;
    watch(phone,async (val) => {
        const isValid = /^09\d{9}$/.test(val)
        if (isValid && !sentOnce.value) {
            const res = await userStore.savePhone(val)
            if(res){
                sentOnce.value = true
                showSend.value = true
                phoneHasFinger()
            }
        } else if (!isValid && sentOnce.value) {
            const result = await userStore.removePhone()
            if(result){
                sentOnce.value = false
                showSend.value = false
                showFingerPrint.value = false
            }
        }
    })
    const submitPhone= async () => {
        if (submitDisabled.value) return
        const res = await userStore.sendLoginCode(phone.value)
        if (res) {
            alertStore.type=true
            alertStore.msg = 'شماره با موفقیت ارسال شد. لطفاً کد پیامکی را وارد کنید.'
            sessionStorage.setItem('login_step', '2')
            sessionStorage.setItem('phone', phone.value)
            const now = Date.now()
            const expireTime = now + 60000 
            sessionStorage.setItem('resend_code_timer', expireTime)
            startTimer()
            emit('success', phone.value)
            showSend.value = true
            sentOnce.value = true
        } else {
            alertStore.msg = res.message || 'ارسال موفق نبود'
        }
    }
    const startTimer = () => {
        const now = Date.now()
        const expireTime = now + 30000 
        sessionStorage.setItem('submit_phone_timer', expireTime)
        updateRemainingTime()
        interval = setInterval(updateRemainingTime, 1000)
    }
    const updateRemainingTime = () => {
        submitDisabled.value=true
        const expireTime = parseInt(sessionStorage.getItem('submit_phone_timer') || 0)
        const now = Date.now()
        const diff = Math.ceil((expireTime - now) / 1000)
        remainingTime.value = diff > 0 ? diff : 0
        if (remainingTime.value <= 0 && interval) {
            submitDisabled.value=false
            clearInterval(interval)
            interval = null
        }
    }
    onMounted(() => {
        updateRemainingTime()
        interval = setInterval(updateRemainingTime, 1000)
        if(props.phone!=='') phone.value=props.phone;
    })
    onUnmounted(() => {
        if (interval) clearInterval(interval)
    })
</script>
<style scoped>
    form {
        width: 100%;
    }
    .msg{
        border-radius: 10px;
        font-weight: bolder;
        color: #970505;
        padding: 2px;
        text-align: center;
        margin: 10px auto 0px auto;
    }
    label,
    input,
    button {
        display: block;
        width: 100%;
        margin-bottom: 10px;
    }
    label{
        text-align: center;
    }
    button{
        background-color: green;
        color: white;
        padding: 9px;
        border-radius: 10px;
        border: none;
        margin-top: 10px;
    }
    button[disabled] {
        opacity: 0.6;
        background-color: rgb(143, 141, 141);
        cursor: not-allowed;
    }
    input {
        box-sizing: border-box;
        padding: 7px;
        border: none;
        outline: none;
        border-radius: 10px;
        background-color: #edefff;
    }
</style>